import { USER_FORGOT_CREDENTIAL } from '../actions/types'

const forgotCredential = (state = '', action) => {
  switch (action.type) {
    case USER_FORGOT_CREDENTIAL:
      return action.payload
    default:
      return state
  }
}

export { forgotCredential }
